var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ev-hotspot",class:{ show: _vm.show },style:(_vm.style)},[_c('button',{staticClass:"ev-hotspot-inside",style:(_vm.btnStyle),on:{"click":_vm.onClick}},[_c('PlusSign')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }